import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  PREFIX_CODE,
  PREFIX_CODE_ADD,
  PREFIX_CODE_ROW_DATA,
  PREFIX_CODE_DELETE,
} from "./actionTypes";
import {
  apiError,
  getPrefixCode,
  PrefixCodeListSuccessful,
  ItemRowDataSuccessful,
  PrefixCodeAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getPrefixCodeData({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/masters/locationwiseprefixs/",
      params
    );
    yield put(PrefixCodeListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* PerFixCodeRowData({ payload: { PreFixCodeID } }) {
  try {
    const response = yield call(
      getList,
      "/masters/locationwiseprefixs/" + PreFixCodeID,
      {}
    );
    yield put(
      ItemRowDataSuccessful({
        response: {
          ...response,
          LocationLabel: response.location ? response.location.name : "",
          Location_id: response.location ? response.location.id : "",
        },
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
//If user is login then dispatch redux action's are directly from here.
function* AddPrefixCode({ payload: { data } }) {
  try {
    if (data.id == null) {
      const response = yield call(
        postAdd,
        "/masters/locationwiseprefixs/",
        data
      );
      if (response.status === 201) {
        swal("Your PreFix Code Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getPrefixCode());
      } else {
        swal("Sorry! Unable to added PreFix Code. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(PrefixCodeAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/locationwiseprefixs/" + data.id,
        data
      );
      if (response.status === 200) {
        swal("Your PreFix Code Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getPrefixCode());
      } else {
        swal("Sorry! Unable to edit PreFix Code. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(PrefixCodeAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeletePreFixCode({ payload: { PreFixCodeID } }) {
  try {
    const response = yield call(
      postDelete,
      "/masters/locationwiseprefixs/" + PreFixCodeID
    );

    if (response.status === 204) {
      swal(" Your PreFix Code has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getPrefixCode());
    } else {
      swal("Sorry! Your PreFix Code has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetPrefixCode() {
  yield takeEvery(PREFIX_CODE, getPrefixCodeData);
}
export function* watchPrefixCodeAdd() {
  yield takeEvery(PREFIX_CODE_ADD, AddPrefixCode);
}
export function* watchPrefixCodeRowData() {
  yield takeEvery(PREFIX_CODE_ROW_DATA, PerFixCodeRowData);
}

export function* watchPreFixCodeDelete() {
  yield takeEvery(PREFIX_CODE_DELETE, DeletePreFixCode);
}

function* PerFixCodeSaga() {
  yield all([
    fork(watchgetPrefixCode),
    fork(watchPrefixCodeAdd),
    fork(watchPrefixCodeRowData),
    fork(watchPreFixCodeDelete),
  ]);
}

export default PerFixCodeSaga;
